// 1代表SingleBet，每个选项下一注，2代表MultipleBet，所有非同一个Event的选项串为一注，3代表SystemBet，串注组合, orderType为4代表方案1（FlexibleBet），orderType为5代表方案2（suppleBet
export const orderTypeMap = {
  single: 1,
  multiple: 2,
  system: 3,
  flexible: 4,
  supple: 5
}
